export function toRadians(degrees) {
  return (Number(degrees) * Math.PI) / 180;
}

export function distanceInMeters(from, to) {
  if (!from || !to) return Infinity;

  const lat1 = Number(from.latitude ?? from.lat);
  const lng1 = Number(from.longitude ?? from.lng ?? from.lon);
  const lat2 = Number(to.latitude ?? to.lat);
  const lng2 = Number(to.longitude ?? to.lng ?? to.lon);

  if (![lat1, lng1, lat2, lng2].every(Number.isFinite)) {
    return Infinity;
  }

  const earthRadius = 6371000;
  const dLat = toRadians(lat2 - lat1);
  const dLng = toRadians(lng2 - lng1);
  const lat1Rad = toRadians(lat1);
  const lat2Rad = toRadians(lat2);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLng / 2) ** 2;

  return 2 * earthRadius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function hasMovedEnough(previousPosition, nextPosition, minDistanceMeters = 30) {
  if (!previousPosition) return true;
  return distanceInMeters(previousPosition, nextPosition) >= minDistanceMeters;
}

export function roundCoordinate(value, decimals = 5) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return null;
  const factor = 10 ** decimals;
  return Math.round(numericValue * factor) / factor;
}
